export default "__VITE_ASSET__0019c10b__"